import css from 'styled-jsx/css';
import { rgba } from 'common/styling/theme';
const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .PaymentsInfoPanelWrap {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    margin-bottom: 20px;
  }

  .PaymentsInfoPanel {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 32px;

    .PaymentsInfoPanel__header {
      display: flex;
      justify-content: space-between;

      @include respond-to(sm) {
        flex-direction: column;
        gap: 24px;
      }

      &-left {
        display: flex;
        gap: 24px;

        @include respond-to(sm) {
          order: 1;
        }

        &-icon {
          width: 48px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;

          svg {
            width: 18px;
            height: 17px;
            margin-left: 2px;
            margin-top: 1px;

            path {
              fill: #fff;
            }
          }
        }

        &-title {
          display: flex;
          flex-direction: column;
          gap: 4px;

          &-amount {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.5);
          }

          &-value {
            .MoneyCell__inner span {
              font-size: 36px;
              font-weight: 500;
            }
          }
        }
      }

      &-status {
        .StatusCell {
          height: fit-content;
        }
      }
    }

    .PaymentsInfoPanel__main {
      display: flex;
      gap: 24px;

      @include respond-to(sm) {
        flex-direction: column;
      }

      &-left-content {
        flex-basis: 334px;
        padding: 32px;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        gap: 32px;

        @include respond-to(sm) {
          flex-basis: unset;
          order: 1;
          flex-grow: 1;
        }
      }

      &-statuses {
        display: flex;
        flex-direction: column;
        gap: 32px;
      }

      &-requires-action {
        padding: 24px;
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        gap: 8px;

        &-text {
          color: rgba(0, 0, 0, 0.5);
        }
      }
    }

    .PaymentInfo {
      display: grid;
      grid-template-columns: minmax(30px, auto) repeat(auto-fit, minmax(100px, 1fr));
      gap: 32px;

      &__item {
        display: flex;
        flex-direction: column;
        gap: 4px;

        &-title {
          color: rgba(0, 0, 0, 0.5);
        }
      }
    }
  }

  .Instruction {
    display: grid;
    gap: 32px;
    grid-template-columns: 80px auto;
    padding: 32px;
    @include respond-to(xs) {
      padding: 16px;
      gap: 24px;
    }

    &__Icon {
      display: flex;
      justify-content: center;
      width: 100%;
      max-height: 80px;

      > img {
        width: 80px;
        object-fit: scale-down;
      }
    }

    &__CustomMessage {
      width: 100%;
      word-break: break-word;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .PaymentsInfoPanel {
      background-color: ${colors.white.hex};

      .PaymentsInfoPanel__header-left-icon {
        background-color: ${colors.primary.hex};
      }

      .PaymentsInfoPanel__main-left-content {
        background-color: ${colors.bodyBackground.hex};
      }

      .PaymentsInfoPanel__main-requires-action {
        background-color: ${rgba([colors.warning.rgb, 0.15])};
      }
    }

    .Instruction {
      background-color: ${colors.white.hex};
    }
  `;
};

export { staticStyles, getDynamicStyles };
